import { TruckDataListing } from "../../../../../models/TruckDetailListing/truckDetailListing.model";
import { MdDelete, MdEdit } from "react-icons/md";
import { EllipsisOutlined } from "@ant-design/icons";
import { Button, Col, Popover, Row } from "antd";
import React from "react";
import styles from "./TruckDetails.module.scss";
import ConditionalRender from "../../../../../reusable-components/ConditionalRender";
import { openGoogleMapsUtil } from "../../../../../utils/openGoogleMaps";
import * as Yup from "yup";
import { formatNumber } from "../../../../../utils/numberFormatterUtil";
import clsx from "clsx";
export const CONSTANTS_DATA = {
  NO_DATA: "No orders have been added yet",
  ADD_TRUCK_BTN_TXT: "Add Trucking Order",
  ADD_TRUCK_DETAILS_TXT: "Add Truck Details",
  WIDTH: "80%",
  HEIGHT: "100vh",
};
export const drawerHeaderStyles = {
  backgroundColor: "#586370",
  padding: "1rem",
  paddingLeft: "2.75rem",
  color: "white",
};

export const DOLLAR_PREFIX = "$";

export const tableData = [
  {
    truckType: ["RB", "ED", "BD"],
    pickupLocation: "Balm Texas",
    deliveryLocation: "Balm Texas",
    milesDuration: "9 min 5.4 mil",
    materialName: "Disposal -vndfjbnfkbngmbg jdn nd ndghljgnhn",
    truckingCost: 8.75,
    truckingCostType: "Ton",
    truckingPrice: 8.75,
    truckingPriceType: "Ton",
  },
];
export const truckColumns = ({
  isEditable,
  handleDeleteRow,
  handleEditRow,
  handleOpenBidTool,
}: {
  isEditable?: boolean;
  handleDeleteRow?: (row?: any) => void;
  handleEditRow?: (row?: any) => void;
  handleOpenBidTool?: (record?:any) => void;
}) => [
  {
    title: "Pickup Location",
    dataIndex: "pickupLocation",
    key: "pickupLocation",
    sorter: false,
    className: "col_styling",
    render: (text, record) => {
      return (
        <>
          <span
            style={{
              color: "#505050",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "17.07px",
              fontFamily: "Montserrat ,sans-serif",
            }}
            className={
              clsx("table-font-mobile", {
                [styles.blockedOrder]: !!record?.isBlocked,
              })
            }
          >
            {text}
          </span>
        </>
      );
    },
  },
  {
    title: "Delivery Location",
    dataIndex: "deliveryLocation",
    key: "deliveryLocation",
    sorter: false,
    className: "col_styling",
    render: (text, record) => {
      return (
        <>
          <span
            style={{
              color: "#505050",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "17.07px",
              fontFamily: "Montserrat ,sans-serif",
            }}
            className={
              clsx("table-font-mobile", {
                [styles.blockedOrder]: !!record?.isBlocked,
              })
            }
          >
            {text}
          </span>
        </>
      );
    },
  },
  {
    title: "Miles & Distance",
    dataIndex: "milesDuration",
    key: "milesDuration",
    sorter: false,
    className: "col_styling",
    render: (text, record) => {
      return (
        <>
          <span
            style={{
              color: "#1890FF",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "17.07px",
              fontFamily: "Montserrat ,sans-serif",
              cursor: "pointer",
            }}
            className={
              clsx("table-font-mobile", {
                [styles.blockedOrder]: !!record?.isBlocked,
              })
            }
            onClick={() => {
              const [pickLng, pickLat] = [
                record?.pickUpLatLng?.lng,
                record?.pickUpLatLng?.lat,
              ];
              const [dropLng, dropLat] = [
                record?.dropOffLatLng?.lng,
                record?.dropOffLatLng?.lat,
              ];
              if(!record?.isBlocked)
                openGoogleMapsUtil({
                  pickUpLat: String(pickLat),
                  pickUpLng: String(pickLng),
                  deliveryLat: String(dropLat),
                  deliveryLng: String(dropLng),
                });
            }}
          >
            {`${record?.duration?.text}, ${record?.milesData?.text}`}
          </span>
        </>
      );
    },
  },
  {
    title: "Truck Type",
    dataIndex: "truckType",
    key: "truckType",
    sorter: false,
    className: "col_styling",
    render: (truckType, record) => {
      return (
        <>
          <span
            style={{
              color: "#505050",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "17.07px",
              fontFamily: "Montserrat ,sans-serif",
            }}
            className={
              clsx("table-font-mobile", {
                [styles.blockedOrder]: !!record?.isBlocked,
              })
            }
          >
            {Array.isArray(truckType) ? truckType.join(" , ") : truckType || ""}
          </span>
        </>
      );
    },
  },
  {
    title: "Material",
    dataIndex: "materialTruckName",
    key: "materialTruckName",
    sorter: false,
    className: "col_styling",
    render: (text, record) => {
      return (
        <>
          <span
            style={{
              color: "#505050",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "17.07px",
              fontFamily: "Montserrat ,sans-serif",
            }}
            className={
              clsx("table-font-mobile", {
                [styles.blockedOrder]: !!record?.isBlocked,
              })
            }
          >
            {text}
          </span>
        </>
      );
    },
  },
  {
    title: "Trucking Cost",
    dataIndex: "truckingCost",
    key: "truckingCost",
    sorter: false,
    className: "col_styling",
    render: (text, record: TruckDataListing) => {
      return (
        <>
          <span
            style={{
              color: "#505050",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "17.07px",
              fontFamily: "Montserrat ,sans-serif",
            }}
            className={
              clsx("table-font-mobile", {
                [styles.blockedOrder]: !!record?.isBlocked,
              })
            }
          >
            {"$ " +
              formatNumber(Number(text).toFixed(2)) +
              " / " +
              record?.truckingCostType}
          </span>
        </>
      );
    },
  },
  {
    title: "Trucking Price",
    dataIndex: "truckingPrice",
    key: "truckingPrice",
    sorter: false,
    className: "col_styling",
    render: (text, record) => {
      return (
        <>
          <span
            style={{
              color: "#505050",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "17.07px",
              fontFamily: "Montserrat ,sans-serif",
            }}
            onClick={() => {
              handleOpenBidTool(record);
            }}
            className={
              clsx("table-font-mobile", {
                [styles.blockedOrder]: !!record?.isBlocked,
                [styles.truckingPriceHighlight]: true,
              })
            }
          >
            {"$ " +
              formatNumber(Number(text).toFixed(2)) +
              " / " +
              record?.truckingPriceType}
          </span>
        </>
      );
    },
  },
  ...(!!isEditable
    ? [
        {
          title: "",
          dataIndex: "actions",
          key: "actions",
          sorter: false,
          width: "3%",
          fixed: "right",
          render: (actions, record) => {
            return (
              <Row
                style={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  flexWrap: "nowrap",
                }}
              >
                <ConditionalRender visible={!record?.locked}>
                  <Col>
                    <Popover
                      placement="bottomRight"
                      content={
                        <>
                          <Row
                            className="popovergrid"
                            style={{ maxWidth: "90px" }}
                          >
                            {
                              <Col span={24}>
                                <Button
                                  className="btn_edit"
                                  onClick={() => handleDeleteRow(record)}
                                >
                                  <span className="span_edit">
                                    <MdDelete
                                      className="table-font-mobile"
                                      style={{ marginRight: "5px" }}
                                    />{" "}
                                    Delete
                                  </span>
                                </Button>
                              </Col>
                            }
                          </Row>
                          <ConditionalRender
                            visible={!record?.isBlocked}
                          >
                            <Row
                              className="popovergrid"
                              style={{ maxWidth: "90px" }}
                            >
                              {
                                <Col span={24}>
                                  <Button
                                    className="btn_edit"
                                    onClick={() => handleEditRow(record)}
                                  >
                                    <span>
                                      <MdEdit className="table-font-mobile" />{" "}
                                      Edit
                                    </span>
                                  </Button>
                                </Col>
                              }
                            </Row>
                          </ConditionalRender>
                        </>
                      }
                    >
                      <EllipsisOutlined
                        style={{ fontSize: "30px", color: "#C3C8CD" }}
                        className="action-ellipsis-button"
                      />
                    </Popover>
                  </Col>
                </ConditionalRender>
              </Row>
            );
          },
        },
      ]
    : []),
];

export const getEditTruckDefaultValues = (row) => {
  return {
    pickUpAddress: row?.pickupLocation,
    deleiveryAddress: row?.deliveryLocation,
    milesAndDistance: row?.milesDuration,
    truckType: row?.truckType,
    materialName: row?.materialTruckName,
    materialCost: Number(row?.materialCost)?.toFixed(2) ?? null,
    materialCostType: row?.materialCostType ?? null,
    materialPrice: Number(row?.materialPrice)?.toFixed(2) ?? null,
    materialPriceType: row?.materialPriceType ?? null,
    truckingCost: row?.truckingCost
      ? formatNumber(Number(row?.truckingCost)?.toFixed(2))
      : null,
    truckingCostType: row?.truckingCostType,
    truckingPrice: row?.truckingPrice
      ? formatNumber(Number(row?.truckingPrice)?.toFixed(2))
      : null,
    truckingPriceType: row?.truckingPriceType,
    landedPrice: Number(row?.landedPrice)?.toFixed(2) ?? null,
    landedPriceType: row?.landedPriceType ?? null,
    minimumHours: row?.minimumHours
      ? Number(row?.minimumHours)?.toFixed(2)
      : undefined,
    id: row?.uniqKey,
  };
};

export const getEditTruckRowData = (row) => {
  return {
    pickUpAddress: row?.pickupLocation,
    deleiveryAddress: row?.deliveryLocation,
    milesAndDistance: row?.milesDuration,
    truckType: row?.truckType,
    materialName: row?.materialTruckName,
    materialCost: Number(row?.materialCost)?.toFixed(2) ?? null,
    materialCostType: row?.materialCostType ?? null,
    materialPrice: Number(row?.materialPrice)?.toFixed(2) ?? null,
    materialPriceType: row?.materialPriceType ?? null,
    truckingCost: Number(row?.truckingCost)?.toFixed(2),
    truckingCostType: row?.truckingCostType,
    truckingPrice: Number(row?.truckingPrice)?.toFixed(2),
    truckingPriceType: row?.truckingPriceType,
    landedPrice: Number(row?.landedPrice)?.toFixed(2) ?? null,
    landedPriceType: row?.landedPriceType ?? null,
    minimumHours: row?.minimumHours,
    id: row?.uniqKey,
  };
};

export const editTruckDetailValues = {
  header: "Edit Trucking Details",
  cancelButtonLabel: "Cancel",
  saveButtonLabel: "Save",
};

export const drawerHeaderStyle = {
  backgroundColor: "#586370",
  padding: "1rem",
  color: "white",
};
const cleanNumber = (value: any, originalValue: any) => {
  if (typeof originalValue === "string") {
    const cleaned = originalValue.replace(/,/g, "").trim();
    if (cleaned === "") return undefined;
    const parsed = Number(cleaned);
    return isNaN(parsed) ? undefined : parsed;
  }
  return value;
};

export const editTrucksValidationSchema = Yup.object({
  truckingPrice: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .typeError("Invalid entry")
    .test("is-required", "required", (v) => v !== undefined && v !== null)
    .min(0, "Trucking price cannot be negative"),
  truckingCost: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .typeError("Invalid entry")
    .test("is-required", "required", (v) => v !== undefined && v !== null)
    .min(0, "Trucking cost cannot be negative"),
  minimumHours: Yup.number()
    .nullable()
    .transform(cleanNumber)
    .typeError("Invalid entry")
    .min(0, "Minimum Hours cannot be negative"),
});
